import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__top" }
const _hoisted_3 = { class: "footer__margin footer__logo-contact" }
const _hoisted_4 = { class: "footer__logo" }
const _hoisted_5 = ["src", "height", "width"]
const _hoisted_6 = { class: "footer__contact" }
const _hoisted_7 = { class: "footer__contact-title" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Contact us")
const _hoisted_9 = { class: "footer_bottom" }
const _hoisted_10 = { class: "footer__margin footer__content" }
const _hoisted_11 = { class: "footer__links-container" }
const _hoisted_12 = { class: "footer__title" }
const _hoisted_13 = { class: "footer__links" }
const _hoisted_14 = { class: "footer__links-container" }
const _hoisted_15 = { class: "footer__title" }
const _hoisted_16 = { class: "footer__links" }
const _hoisted_17 = { class: "footer__offices-container" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "footer__title" }, "Offices", -1)
const _hoisted_19 = { class: "footer__offices" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "footer__margin footer__phone-contact" }
const _hoisted_22 = { class: "footer__contact-title" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Contact us")
const _hoisted_24 = { class: "footer__margin footer__social-media-and-copyright" }
const _hoisted_25 = { class: "footer__social-media" }
const _hoisted_26 = { class: "footer__copyright" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Privacy Policy")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "footer__logo-image",
            src: _ctx.logoLight?.filename,
            height: _ctx.logoLight?.height,
            width: _ctx.logoLight?.width
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.texts?.['footer__contact-title']), 1),
          _createVNode(_component_router_link, {
            to: _ctx.resolveLink(() => _ctx.settings?.contactLink)?.url,
            class: "button button--light footer__contact-button"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.texts?.['footer__links-title']), 1),
          _createElementVNode("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings?.footerLinks, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item._uid,
                class: "footer__links-item"
              }, [
                _createVNode(_component_router_link, {
                  to: _ctx.resolveLink(() => item.link)?.url,
                  target: item.target,
                  class: "footer__links-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "target"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.texts?.['footer__links2-title']), 1),
          _createElementVNode("ul", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings?.footerLinks2, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item._uid,
                class: "footer__links-item"
              }, [
                _createVNode(_component_router_link, {
                  to: _ctx.resolveLink(() => item.link)?.url,
                  target: item.target,
                  class: "footer__links-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "target"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("ul", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings?.offices, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item._uid,
                class: "footer__offices-item",
                innerHTML: _ctx.renderMarkdownInline(item.body)
              }, null, 8, _hoisted_20))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.texts?.['footer__contact-title']), 1),
        _createVNode(_component_router_link, {
          to: _ctx.resolveLink(() => _ctx.settings?.contactLink)?.url,
          class: "button button--light footer__contact-button"
        }, {
          default: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("ul", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings?.socialMedia, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item._uid,
              class: "footer__social-media-item"
            }, [
              _createVNode(_component_router_link, {
                to: _ctx.resolveLink(() => item.link)?.url,
                target: item.target
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "target"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createTextVNode(" © " + _toDisplayString((new Date()).getFullYear()) + " DISTANCIFY AB. All rights reserved. | ", 1),
          _createVNode(_component_router_link, {
            to: _ctx.resolveLink(() => _ctx.settings?.privacyPolicyLink)?.url
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}